/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: JacquelineM (https://sketchfab.com/JacquelineM)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/light-bulb-b05d65aada034ccebdc73d5982108ea2
title: Light Bulb
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function LightBulbModel(props) {
  const { nodes, materials } = useGLTF("../assets/models/light_bulb/scene.glb");
  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_2.geometry}
          material={materials.Material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_3.geometry}
          material={materials.transparente_del_foco}
        />
      </group>
    </group>
  );
}

useGLTF.preload("../assets/models/light_bulb/scene.glb");
